var _g, _path, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyWorkspaces(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 234,
    viewBox: "0 0 234 234",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#empty-workspaces_svg__filter0_d_3212_82256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.998 224.437c8.814.622 16.002-6.6 16.002-15.437V17c0-8.837-7.163-16-16-16H17C8.163 1 .94 8.188 1.563 17.002c7.831 110.944 96.462 199.603 207.435 207.435z",
    fill: "#FFF2E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.963 224.936c9.126.644 16.537-6.833 16.537-15.936V17c0-9.113-7.387-16.5-16.5-16.5H17C7.897.5.42 7.91 1.064 17.037c7.85 111.193 96.677 200.049 207.899 207.899z",
    stroke: "#000"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#171718",
    d: "M124.486 101.513h100.513v100.513H124.486z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "empty-workspaces_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 224,
    height: 224
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M208.998 224.437c8.814.622 16.002-6.6 16.002-15.437V17c0-8.837-7.163-16-16-16H17C8.163 1 .94 8.188 1.563 17.002c7.831 110.944 96.462 199.603 207.435 207.435z",
    fill: "#C7DAFF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#empty-workspaces_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFE6D9",
    stroke: "#2E2E2E",
    d: "M23.475 101.013h101.513v101.513H23.475z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.743 1h-50.257v50.257c27.752 0 50.257-22.496 50.257-50.257zM225 51.256V1h-50.257c0 27.752 22.496 50.256 50.257 50.256z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.487 51.256v50.257h50.256c0-27.752-22.496-50.257-50.256-50.257zM174.743 101.513h50.256V51.257c-27.752 0-50.256 22.496-50.256 50.256z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.999 51.256c-27.76 0-50.256-22.504-50.256-50.256 0 27.76-22.505 50.256-50.257 50.256 27.761 0 50.257 22.505 50.257 50.257 0-27.76 22.504-50.257 50.256-50.257z",
    fill: "#59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.185 174.796a1.659 1.659 0 00-.148.676c0 3.297 5.407 8.638 8.638 8.638.233-.001.464-.052.676-.148l11.688-5.21a45.056 45.056 0 01-8.787-6.89 45.935 45.935 0 01-6.841-8.754l-5.226 11.688zM153.807 148.637l-4.699 10.583a39.292 39.292 0 007.517 10.303 37.697 37.697 0 0010.303 7.517l10.798-4.797a43.129 43.129 0 01-14.424-9.693 43.347 43.347 0 01-9.495-13.913zM161.573 132.036a4.558 4.558 0 00-1.137 1.648l-4.665 10.534a37.919 37.919 0 009.89 15.957 37.924 37.924 0 0016.485 10.072l10.253-4.583a4.637 4.637 0 001.649-1.137c3.396-4.945-10.319-18.957-11.951-20.589-1.632-1.632-15.595-15.282-20.524-11.902zm29.837 30.496c-1.796 0-8.242-3.544-16.237-11.539-7.995-7.995-11.539-14.44-11.539-16.237 1.78 0 8.242 3.56 16.204 11.539 7.962 7.979 11.572 14.457 11.572 16.237zM178.648 131.178c2.604-2.605 2.819-4.187 2.819-5.836 0-.956 0-1.648 1.846-3.494a1.65 1.65 0 000-2.325 1.649 1.649 0 00-2.324 0c-2.605 2.588-2.819 4.171-2.819 5.819 0 .957 0 1.649-1.846 3.495a1.638 1.638 0 00-.361 1.805 1.645 1.645 0 002.685.536zM204.251 142.832c-1.846 1.846-2.539 1.846-3.495 1.846-1.648 0-3.297.214-5.835 2.819a1.65 1.65 0 102.341 2.324c1.846-1.846 2.538-1.846 3.494-1.846 1.649 0 3.297-.214 5.819-2.819a1.648 1.648 0 000-2.324 1.645 1.645 0 00-2.324 0zM184.469 136.998c4.038-4.039 4.78-5.572 5.44-6.907a11.172 11.172 0 012.802-3.577 1.655 1.655 0 00.361-1.805 1.65 1.65 0 00-2.685-.536 14.405 14.405 0 00-3.297 4.467c-.544 1.121-1.154 2.374-4.797 6.033a1.653 1.653 0 00-.802 1.933 1.646 1.646 0 002.978.392zM199.633 133.436a11.184 11.184 0 01-3.626 2.786c-1.336.66-2.869 1.401-6.907 5.44a1.651 1.651 0 00-.463 1.853c.083.212.209.404.369.565a1.66 1.66 0 001.23.481 1.635 1.635 0 001.188-.575c3.66-3.643 4.945-4.253 6.033-4.797a14.421 14.421 0 004.468-3.297 1.645 1.645 0 000-2.324 1.65 1.65 0 00-2.292-.132z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.976 101.513v100.512h100.512c0-55.503-44.992-100.512-100.513-100.512z",
    fill: "#FFB066"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M262.334 1H161.821c55.521 0 100.513 45.01 100.513 100.513V1z",
    fill: "#FFE6D9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59F",
    d: "M124.486 202.025h100.513v100.513H124.486z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#171718",
    d: "M23.975 1h100.513v100.513H23.975z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#59F",
    d: "M-76.539 1H23.974v100.513H-76.539z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.837 17.7a3.354 3.354 0 00-.724 4.69l14.536 19.843a.745.745 0 11-1.204.881l-9.47-12.929-3.302-4.509a3.355 3.355 0 00-5.413 3.965l12.774 17.437a.745.745 0 11-1.203.881l-8.81-12.026a3.354 3.354 0 10-5.412 3.965l8.81 12.026h-.001l1.675 2.288.157.212 1.914 2.613.203-.15a23.969 23.969 0 0015.543 7.094l-1.225.897 9.23 12.599A6 6 0 0089.3 78.77l8.961-6.564a6 6 0 001.295-8.386l-5.698-7.78c3.53-4.237 3.87-10.484.464-15.135l-.034-.046-3.93-5.366-7.93-10.825a6.709 6.709 0 00-1.447 9.376l1.453 1.985h-.002l4.053 5.533a.746.746 0 01-1.203.881l-9.47-12.929.001-.002-9.91-13.529a3.355 3.355 0 00-5.412 3.965l12.773 17.438a.745.745 0 11-1.202.882h-.001L57.525 18.424a3.354 3.354 0 00-4.688-.724z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.41 12.486c0 .431.288.718.719.718 2.728 0 5.24 1.077 7.179 2.944 1.867 1.939 2.944 4.451 2.944 7.18a.72.72 0 00.718.718c.43 0 .718-.288.718-.718 0-3.016-1.221-5.96-3.375-8.185a11.571 11.571 0 00-8.184-3.374c-.36 0-.718.358-.718.717z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.026 23.327c0-2.082-.79-4.092-2.297-5.6-1.508-1.508-3.446-2.297-5.6-2.297-.43 0-.718.287-.718.718 0 .43.287.718.718.718 1.723 0 3.374.646 4.595 1.866a6.416 6.416 0 011.867 4.523c0 .431.287.718.717.718.431.072.718-.215.718-.646zM59.768 76.425c.111-.416-.092-.767-.508-.879-2.635-.706-4.783-2.397-6.173-4.701-1.301-2.356-1.69-5.062-.985-7.697a.72.72 0 00-.507-.88c-.416-.11-.768.092-.88.508-.78 2.913-.363 6.072 1.141 8.78a11.571 11.571 0 007.033 5.377c.346.093.786-.16.879-.508z",
    fill: "#C7DAFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.252 63.724c-.539 2.011-.296 4.158.77 6.004 1.066 1.847 2.734 3.111 4.814 3.669.416.111.768-.092.88-.508.111-.416-.092-.768-.508-.88-1.664-.445-3.092-1.497-3.955-2.992a6.416 6.416 0 01-.633-4.852c.112-.416-.091-.768-.507-.88-.398-.18-.75.023-.861.44z",
    fill: "#C7DAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "empty-workspaces_svg__filter0_d_3212_82256",
    x: 0.525,
    y: 0,
    width: 233.475,
    height: 233.475,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3212_82256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3212_82256",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyWorkspaces);
export default __webpack_public_path__ + "static/media/empty-workspaces.925161231aa01b75340072325be79a99.svg";
export { ForwardRef as ReactComponent };